/**
 * Created by rhillion on 01/07/2017.
 */
import React from 'react'
import {Card, Icon, Image} from 'semantic-ui-react'
import moment from 'moment';

const CardDetails = (params) => (
    <Card>
        <Card.Content>
            <Card.Header>
                {params.card.title}
            </Card.Header>
        </Card.Content>

        <Image src={params.card.image}/>

        <Card.Content>
            <Card.Description>
                {params.card.description}
            </Card.Description>
        </Card.Content>

        <Card.Content>
            <Card.Meta>
                <i title="When" className="calendar icon"></i>
                {params.card.frequency === "date" && params.card.date && ' ' + moment(params.card.date).format('DD/MM/YYYY')}
                {params.card.frequency !== "date" && params.card.days && Object.keys(params.card.days).map(key => ` ${key},`)}
            </Card.Meta>

            <Card.Meta>
                <i title="Time" className="time icon"></i> {params.card.allday ? 'All day' : params.card.timestart + ' to ' + params.card.timeend}
            </Card.Meta>
        </Card.Content>

        <Card.Content extra>
            <span className="right floated">
                {
                    params.card.status === 'active'?
                    <div title="Active" className="ui green empty circular label"></div>:
                    <div title="Inactive" className="ui red empty circular label"></div>
                }
            </span>
            <span>
                <a href={'/cards/edit/' + params.card.id}>
                    <Icon name='edit'/>
                    Edit
                </a>
            </span>

        </Card.Content>
    </Card>
)

export default CardDetails


// WEBPACK FOOTER //
// ./src/CardDetails.js